<template>
  <div>
    <v-btn color="primary" class="elevation-0 ml-6" width="167px" dark :loading="isSelecting" @click="onUploadClick">
      <v-icon left>mdi-upload</v-icon>Upload Excel
    </v-btn>
    <input
      ref="uploader"
      type="file"
      class="d-none"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      @change="onFileChanged"
    />
  </div>
</template>
<script>
import readXlsxFile from 'read-excel-file'
import { IMPORT_SCHEMA } from '../../helpers'
import { mapActions, mapGetters } from 'vuex'
import get from 'lodash-es/get'

const TRANSFORM_DATA_KEYS = ['studentLearningMethods', 'studentProducts', 'studentDepartments']

export default {
  data: () => ({ isSelecting: false }),
  computed: { ...mapGetters({ configs: 'leadConfig/configs' }) },
  methods: {
    ...mapActions({
      fetchLeadProgress: 'lead/fetchLeadProgress',
      updateLeadProgress: 'lead/updateLeadProgress',
      setImportedItems: 'lead/setImportedItems',
    }),
    reset() {
      this.$refs.uploader.value = null
    },
    clickUploadSection() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    async onUploadClick() {
      this.$loading.active = true
      const progress = await this.fetchLeadProgress()
      if (progress.status === 'available') this.clickUploadSection()
      else if (progress.status === 'finish') {
        this.$alert.success('Thao tác upload trước đã thành công! Xin Vui lòng upload tiếp.')
        await this.updateLeadProgress({ id: progress.id, status: 'available' })
        const existedList = get(progress, 'data.existedList')
        if (Array.isArray(existedList) && existedList.length) this.$emit('fillExistedList', existedList)
        else this.clickUploadSection()
      } else if (progress.status === 'creating') {
        this.$emit('openProgressDialog')
      }
      this.$loading.active = false
    },
    transformData(items = []) {
      const mapDict = this.configs
        .map(c => c.value.map(v => ({ key: v.value, value: v.key })))
        .flat()
        .reduce((o, i) => Object.assign(o, { [i.key]: i.value }), {})
      const keys = Object.keys(mapDict)
      items.forEach(item =>
        TRANSFORM_DATA_KEYS.forEach(
          k => (item[k] = keys.filter(_k => item[k].split(' // ').includes(_k)).map(_k => mapDict[_k]))
        )
      )
      this.setImportedItems(items)
    },
    async onFileChanged(e) {
      this.$loading.active = true
      const file = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(file, { schema: IMPORT_SCHEMA })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      }
      this.transformData(readFileResult.rows)
      this.$emit('onImportSuccess')
      this.$loading.active = false
    },
  },
}
</script>